"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aozReducer = void 0;
const aozAction_1 = require("../actions/aozAction");
const object_utils_1 = require("../utils/object-utils");
const initState = {};
const aozReducer = (aoz = initState, action) => {
    switch (action.type) {
        case aozAction_1.ADD_AOZ_PRODUCT_ID_FOR_VEHICLE:
            const aozClone = Object.assign({}, aoz);
            aozClone[action.payload.vehicleId] = [
                ...(aozClone[action.payload.vehicleId] || []),
                action.payload.product,
            ];
            return aozClone;
        case aozAction_1.REMOVE_AOZ_PRODUCT_ID_FROM_VEHICLE:
            const aozRemoveClone = (0, object_utils_1.deepCopy)(aoz);
            if (aozRemoveClone[action.payload.vehicleId]) {
                const entity = aozRemoveClone[action.payload.vehicleId].find((product) => product.ean === action.payload.productEan);
                const index = aozRemoveClone[action.payload.vehicleId].indexOf(entity);
                if (index > -1) {
                    aozRemoveClone[action.payload.vehicleId].splice(index, 1);
                }
                if (!Object.keys(aozRemoveClone[action.payload.vehicleId]).length) {
                    delete aozRemoveClone[action.payload.vehicleId];
                }
            }
            return aozRemoveClone;
        default:
            return aoz;
    }
};
exports.aozReducer = aozReducer;
//# sourceMappingURL=aoz.reducer.js.map